import { Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
    template: `<div class="Spinner">
        <mat-spinner class="Spinner__spinner"></mat-spinner>
        <h3 class="Spinner__label">{{ label() }}</h3>
    </div>`,
    selector: 'app-spinner',
    styleUrls: ['./spinner.scss'],
    imports: [MatProgressSpinnerModule],
})
export class SpinnerComponent {
    readonly label = input<string>(undefined);
}
